import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Web3Provider } from './src/config/Web3Config';
import { AuthProvider } from './src/contexts/AuthContext';
import LandingPage from './src/components/LandingPage';
import PlatformPage from './src/components/PlatformPage';
import Dashboard from './src/components/Dashboard';
import ToastContainer from './src/components/Toast';

const App = () => {
  return (
    <Web3Provider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/platform" element={<PlatformPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
          <ToastContainer />
        </Router>
      </AuthProvider>
    </Web3Provider>
  );
};

export default App;